import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { cn } from "@/lib/utils";
import type { DiagnosesBrowserStepResult } from "@/types/classification";
import { ChevronDown, ChevronRight } from "lucide-react";
import { useState } from "react";
import DebugInfoJsonViewer from "./DebugInfoJsonViewer";

export default function DiagnosesBrowserStepResultCard({ result }: { result: DiagnosesBrowserStepResult }) {
  const [expanded, setExpanded] = useState(false);

  if (!result) return null;

  return (
    <Card className="rounded-md border bg-muted/30">
      <CardHeader>
        <button
          className={cn("flex items-center gap-2 w-full text-left focus:outline-none")}
          onClick={() => setExpanded((prev) => !prev)}
          type="button"
        >
          {expanded ? <ChevronDown className="h-4 w-4 mr-2" /> : <ChevronRight className="h-4 w-4 mr-2" />}
          <span className="font-medium">Diagnoses Index Step Result</span>
        </button>
      </CardHeader>
      {expanded && (
        <CardContent className="space-y-4">
          <div>
            <div className="font-semibold mb-1">Diagnoses</div>
            <div className="flex flex-wrap gap-2">
              {result.diagnoses && result.diagnoses.length > 0 ? (
                result.diagnoses.map((diag) => (
                  <span
                    key={`${diag.code}-${diag.description}`}
                    className="inline-block bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-100 rounded-full px-3 py-1 text-sm font-medium"
                  >
                    {diag.code} - {diag.description}
                  </span>
                ))
              ) : (
                <span className="text-muted-foreground">No diagnoses found</span>
              )}
            </div>
          </div>
          {result.debugInfo && (
            <div>
              <div className="font-semibold mb-1">Debug Info</div>
              <DebugInfoJsonViewer debugInfo={result.debugInfo} />
            </div>
          )}
        </CardContent>
      )}
    </Card>
  );
}
